<template>
  <div class="ly_modal_container" :style="{width: '790px', zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">두뇌톡톡 평균점수별 대상자수</h1>
    </div>
    <div class="ly_modal_content">
      <h2 class="section_title"><span class="ico"></span>조회기간 : <span class="highlight">{{period}}</span></h2>

      <ScrollTable ref="table" :sourceList="avgData">
        <template #header>
          <caption><span class="blind">평균점수별 대상자수</span></caption>
          <colgroup>
            <col width="150">
            <col width="120">
            <col width="120">
            <col width="120">
            <col width="120">
            <col width="120">
          </colgroup>

          <thead class="table_list_head">
          <tr>
            <th>평균점수</th>
            <th>20미만</th>
            <th>20이상</th>
            <th>40이상</th>
            <th>60이상</th>
            <th>80이상</th>
          </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr>
            <td class="right">{{rowData.date}}</td>
            <td class="right">{{rowData.score20}}</td>
            <td class="right">{{rowData.score40}}</td>
            <td class="right">{{rowData.score60}}</td>
            <td class="right">{{rowData.score80}}</td>
            <td class="right">{{rowData.score100}}</td>
          </tr>
        </template>
      </ScrollTable>

      <div class="btn_area">
        <button type="button" class="btn_default" @click="close">닫기</button>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close"><span class="ico">팝업 닫기</span></button>
  </div>
</template>

<script>
  import popupMixin from '$mixins/popup'

  export default {
    extends: popupMixin,
    props: {
      avgData: Array,
      period: String
    }
  }
</script>
